var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 56,
    viewBox: "0 0 224 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: -56,
    r: 112,
    fill: "#9A8C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse8);
export default __webpack_public_path__ + "static/media/Ellipse 8.cde8206d59ab28bd0640f7e8d0acace5.svg";
export { ForwardRef as ReactComponent };